// 빌드 : ./fe-build.sh shareSearch

import 'es6-promise/auto'
import Vue from 'vue'
import Axios from 'axios'
import Pager from "./components/common/pagingUser.vue";
import Common from './components/common.js';
import DatePicker from 'vue2-datepicker';
import Editor from "./components/common/editor.vue";
import VueFileAgent from 'vue-file-agent';
import Validator from './components/common/validation.js';
import swal from 'sweetalert';
import Share from './components/common/share.js';
import 'vue2-datepicker/index.css';
import 'vue-file-agent/dist/vue-file-agent.css';
import mobile from 'is-mobile';
import {debounce} from "lodash";


Vue.use(VueFileAgent);

import DropImg from "./components/common/dragImgFile.vue";
import DropImgOne from "./components/common/dragImgFileOne.vue";
import DropDoc from "./components/common/dragDocFile.vue";
import DropVideo from "./components/common/dragVideoFile.vue";
import SwalAlert from "./components/common/swalAlert.vue";
import Alram from './components/common/alram.vue';
import TotalSearchMykeyword from "./components/common/total_search_mykeyword";


Vue.component("pager", Pager);
Vue.component('common', Common);
Vue.component("datepicker", DatePicker);
Vue.component('editor', Editor);
Vue.component('star-rating', VueStarRating.default);
Vue.component('dropimg', DropImg);
Vue.component('dropimgone', DropImgOne);
Vue.component('dropdoc', DropDoc);
Vue.component('dropvideo', DropVideo);
Vue.component('alarm', Alram);


new Vue({
  el: '#search2Result',
  data: function () {
    return {
      mainName: '통합검색',
      isMobile: false,
      mode: 'thumb',
      mbMainMode: false,
      target: '',
      rightAvail: true,
      leftAvail: false,
      searchKeyword: '',
      isDetailSearch: false,
      searchStartDate: '',
      searchEndDate: '',
      searchDetail: '',
      title: '',
      programp: 1,
      basep: 1,
      clubp: 1,
      galleryp: 1,
      newsp: 1,
      realinfop: 1,
      searchModel: {
        kword: '',
        dpword: '',
        collection: 'program,afterschool,homebase_club,homebase_channel,homebase_challenge,facility,policy_inf',
      },
      expInfoListModel: {
        dateKind: 'accept', // 접수기간
        startDate: '',
        endDate: '',
        collectionList: [
          {text: '체험프로그램', value: 'program'},
          {text: '청소년 숏폼', value: 'homebase_challenge'},
          {text: '동아리', value: 'homebase_channel'},
          {text: '동아리 홍보보드', value: 'homebase_club'},
          {text: '진로커뮤니티', value: 'homebase_gallery'},
          {text: '정보몽땅', value: 'realinfo'},
          {text: '청소년기자단', value: 'youthnews'},
          {text: '서울시공공예약프로그램', value: 'facility'},
          {text: '청소년 시민청원', value: 'voice'},
          {text: '청소년 정책소개', value: 'policy_inf'},
          //{text: '마을방과후', value: 'afterschool'},
          //{text: '마을강사', value: 'teacher'},
          //{text: '마을공간', value: 'space'},
        ],
        regionList: [],
        scopeList: [],
        progressList: [],
        areaList: [],
        affList: [],
        priceList: ["price2", "price3", "price4", "price5", "price6"],
        collectionValues: [],
        regionValues: [],
        priceValues: [],
        progressValues: [],
        scopeValues: [],
        areaValues: [],
        affValues: [],
        allCollectionChecked: false,
        allScopeChecked: false,
        allPriceChecked: false,
        allProgressChecked: false,
        allAreaChecked: false,
        allAbilityChecked: false,
        allLineChecked: false,
      },
      viewModel: {},
      viewYnModel: {
        program: false,
        afterschool: false,
        homebase_channel: false,
        homebase_gallery: false,
        homebase_challenge: false,
        homebase_club: false,
        teacher: false,
        space: false,
        youthnews: false,
        realinfo: false,
        voice: false,
        facility: false,
        policy_inf: false,
        filter: {
          gubun: false,
          region: false,
          price: false,
          progress: false,
          trget: false,
          affiliation: false,
          capacity: false
        },
        mbFilter: {
          status: false
        }
      },
      lang: {
        days: ["일", "월", "화", "수", "목", "금", "토"],
        months: [
          "1월",
          "2월",
          "3월",
          "4월",
          "5월",
          "6월",
          "7월",
          "8월",
          "9월",
          "10월",
          "11월",
          "12월"
        ],
        yearFormat: "YYYY년",
        monthFormat: "MM월",
        monthBeforeYear: false
      },
      // 인기검색어
      popwordList: [],
      // 내가 찾은 검색어
      mywordList: [],
      // 자동 완성
      autowordList: [],
      // 연관 검색어
      recommendList: [],
      list: [],
      showInputArea: false,
    }
  },
  created: function () {
    if (!('$' in Vue.prototype) && '$' in window) {
      Vue.prototype.$ = window.$; // <template> 에서 $ 사용
    }
  },
  mounted: function () {
    this.isMobile = mobile();

    this.searchModel.kword = $("#id_param_kword").val();

    this.title = this.searchModel.kword
    /*if(this.isMobile && this.title == '') {
      this.mbMainMode = true;
    }*/
    this.fnOnLoadInit();
  },
  methods: {
    fnOnLoadInit: function () {
      let vm = this;

      vm.fnSetRegionList(); // 지역
      vm.fnOnSetCode('DIVNVSCLNV000000'); // 대상 ('scope');
      // vm.fnOnSetCode('STSNVAPRNV000100'); // 진행상태 ('progress');
      vm.fnOnSetCode('IXVNV00000'); // 진행상태 ('progress');
      vm.fnOnSetCode('CPCNVADMNV000000'); // 역량 ('area');
      vm.fnOnSetCode('AFLNVADMNV000000'); // 계열 ('aff');

      this.loadPopwordList().then() // 인기검색어 로딩
      this.myKeywordLoad(); // 최근 검색어 로딩

      vm.getSearch();
    }, fnResetFilter(without) {
      let vm = this;
      if (without == 'gubun') {
        vm.viewYnModel.filter.region = false;
        vm.viewYnModel.filter.price = false;
        vm.viewYnModel.filter.progress = false;
        vm.viewYnModel.filter.trget = false;
        vm.viewYnModel.filter.affiliation = false;
        vm.viewYnModel.filter.capacity = false;
      } else if (without == 'region') {
        vm.viewYnModel.filter.gubun = false;
        vm.viewYnModel.filter.price = false;
        vm.viewYnModel.filter.progress = false;
        vm.viewYnModel.filter.trget = false;
        vm.viewYnModel.filter.affiliation = false;
        vm.viewYnModel.filter.capacity = false;
      } else if (without == 'price') {
        vm.viewYnModel.filter.gubun = false;
        vm.viewYnModel.filter.region = false;
        vm.viewYnModel.filter.progress = false;
        vm.viewYnModel.filter.trget = false;
        vm.viewYnModel.filter.affiliation = false;
        vm.viewYnModel.filter.capacity = false;
      } else if (without == 'progress') {
        vm.viewYnModel.filter.gubun = false;
        vm.viewYnModel.filter.price = false;
        vm.viewYnModel.filter.region = false;
        vm.viewYnModel.filter.trget = false;
        vm.viewYnModel.filter.affiliation = false;
        vm.viewYnModel.filter.capacity = false;
      } else if (without == 'trget') {
        vm.viewYnModel.filter.gubun = false;
        vm.viewYnModel.filter.price = false;
        vm.viewYnModel.filter.progress = false;
        vm.viewYnModel.filter.region = false;
        vm.viewYnModel.filter.affiliation = false;
        vm.viewYnModel.filter.capacity = false;
      } else if (without == 'affiliation') {
        vm.viewYnModel.filter.gubun = false;
        vm.viewYnModel.filter.price = false;
        vm.viewYnModel.filter.progress = false;
        vm.viewYnModel.filter.trget = false;
        vm.viewYnModel.filter.region = false;
        vm.viewYnModel.filter.capacity = false;
      } else if (without == 'capacity') {
        vm.viewYnModel.filter.gubun = false;
        vm.viewYnModel.filter.price = false;
        vm.viewYnModel.filter.progress = false;
        vm.viewYnModel.filter.trget = false;
        vm.viewYnModel.filter.affiliation = false;
        vm.viewYnModel.filter.region = false;
      } else {
        vm.viewYnModel.filter.gubun = false;
        vm.viewYnModel.filter.region = false;
        vm.viewYnModel.filter.price = false;
        vm.viewYnModel.filter.progress = false;
        vm.viewYnModel.filter.trget = false;
        vm.viewYnModel.filter.affiliation = false;
        vm.viewYnModel.filter.capacity = false;
      }


    }
    , fnInsertZzim(_item) {
      let _userKey = $("#usrKey").val();

      if (_userKey != null && _userKey != "") {
        _item.isZzim = !_item.isZzim
        _item.zzimYn = (_item.isZzim) ? 'Y' : 'N';
        this.$forceUpdate();
        let param = {
          programUid: _item.UIDKEY,
          zzimYn: _item.zzimYn
        };

        Axios.post("/api/expinfo/checkZzim", param).then(function (response) {
          let result = response.data.result;
        }).catch(function (ex) {
          alert("오류가 발생했습니다.");
          console.log(ex);
        });
      } else {
        swal({
          text: "찜하기는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          // // icon: this.fnOnLoadSwalImageData("info"),
          closeOnClickOutside: false,
          buttons: {
            confirm: {text: "확인", value: true, visible: true},
            cancel: {text: "취소", value: false, visible: true}
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
      }
    }, fnOpenFilter() {
      $('body').css('overflow-y','hidden');
      this.fnClickFilter('region');
      this.viewYnModel.filter.region = true;
      this.viewYnModel.mbFilter.status = true;
    }, fnCloseFilter() {
      this.viewYnModel.mbFilter.status = false;
      $('body').css('overflow-y','unset');
    },
    fnClickFilter(_code) {
      let vm = this;

      if (_code == 'gubun') {
        this.fnResetFilter('gubun');
        vm.viewYnModel.filter.gubun = !vm.viewYnModel.filter.gubun;
      } else if (_code == 'region') {
        this.fnResetFilter('region');
        vm.viewYnModel.filter.region = !vm.viewYnModel.filter.region;
      } else if (_code == 'price') {
        this.fnResetFilter('price');
        vm.viewYnModel.filter.price = !vm.viewYnModel.filter.price;
      } else if (_code == 'progress') {
        this.fnResetFilter('progress');
        vm.viewYnModel.filter.progress = !vm.viewYnModel.filter.progress;
      } else if (_code == 'trget') {
        this.fnResetFilter('trget');
        vm.viewYnModel.filter.trget = !vm.viewYnModel.filter.trget;
      } else if (_code == 'affiliation') {
        this.fnResetFilter('affiliation');
        vm.viewYnModel.filter.affiliation = !vm.viewYnModel.filter.affiliation;
      } else if (_code == 'capacity') {
        this.fnResetFilter('capacity');
        vm.viewYnModel.filter.capacity = !vm.viewYnModel.filter.capacity;
      } else if (_code == '') {
        this.fnResetFilter();
      }
    }
    , allReset() {
      let vm = this;

      vm.viewYnModel.filter.gubun = false;
      vm.viewYnModel.filter.price = false;
      vm.viewYnModel.filter.region = false;
      vm.viewYnModel.filter.trget = false;
      vm.viewYnModel.filter.affiliation = false;
      vm.viewYnModel.filter.capacity = false;
    }
    , fnSetRegionList() {
      let vm = this;
      Axios.post("/api/expinfo/setSeoulAreaList", {}).then(function (response) {
        vm.expInfoListModel.regionList = response.data.expinfoCodeList;
      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , fnOnSetCode: function (_code) {
      let vm = this;
      let param = {searchCode: _code};

      Axios.post("/api/expinfo/code", param).then(function (response) {

        if (_code === 'DIVNVSCLNV000000') {
          vm.expInfoListModel.scopeList = response.data.expinfoCodeList;
          // }else if(_code === 'STSNVAPRNV000100'){
        } else if (_code === 'IXVNV00000') {
          // 조성이 팀장님 요청으로 오류, 일시신청중지 삭제
          vm.expInfoListModel.progressList = [];
          response.data.expinfoCodeList.forEach(function(item) {
            if(item.cmm_sys_cd != 'IXVNV00006' && item.cmm_sys_cd != 'IXVNV00009') {
              vm.expInfoListModel.progressList.push(item);
            }
          });
          //vm.expInfoListModel.progressList = response.data.expinfoCodeList;
        } else if (_code === 'CPCNVADMNV000000') {
          vm.expInfoListModel.areaList = response.data.expinfoCodeList;
        } else if (_code === 'AFLNVADMNV000000') {
          vm.expInfoListModel.affList = response.data.expinfoCodeList;
        } else if (_code === 'ESGNVMNGNV00000') {
          vm.expInfoListModel.esgList = response.data.expinfoCodeList;
        } else if (_code === 'SCHDNVYTHNV00000') {
          vm.expInfoListModel.planList = response.data.expinfoCodeList;
          if (vm.expInfoListModel.planList.length > 0) {
            vm.expInfoListModel.planList.forEach(function (object) {
              if (object.cmm_sys_cd === response.data.expinfoCodeList.cmm_sys_cd) {
                vm.selectPlanType = object;
              }
            });
          }
        }

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , fnFindMore(target) {
      if (target == null) {
        this.mode = 'thumb';
        this.target = '';
      } else {
        this.mode = 'detail';
        this.target = target;
      }
    }
    , fnReset() {
      let vm = this;

      vm.expInfoListModel.collectionValues = [];
      vm.expInfoListModel.regionValues = [];
      vm.expInfoListModel.priceValues = [];
      vm.expInfoListModel.progressValues = [];
      vm.expInfoListModel.scopeValues = [];
      vm.expInfoListModel.areaValues = [];
      vm.expInfoListModel.affValues = [];

      vm.expInfoListModel.allCollectionChecked = false;
      vm.expInfoListModel.allScopeChecked = false;
      vm.expInfoListModel.allPriceChecked = false;
      vm.expInfoListModel.allProgressChecked = false;
      vm.expInfoListModel.allAreaChecked = false;
      vm.expInfoListModel.allAbilityChecked = false;
      vm.expInfoListModel.allLineChecked = false;

      vm.expInfoListModel.dateKind = 'accept';
      vm.expInfoListModel.startDate = '';
      vm.expInfoListModel.endDate = '';
      vm.searchStartDate = '';
      vm.searchEndDate = '';

      vm.getSearch();
    }
    , fnPriceFormatForSearch() {
      const values = this.expInfoListModel.priceValues;

      // price2 // 무료
      // price3 // ~ 5000 // 0 초과 5천이하
      // price4 // 5000 ~ 10000 // 5천초과 1만이하
      // price5 // 10000 ~ 30000 // 1만초과 3만이하
      // price6 // 30000 ~ // 3만초과 이하삭제

      // price	// 가격 검색
      // priceLt	// 가격 미만 검색
      // priceLte	// 가격 이하 검색
      // priceGt	// 가격 초과 검색
      // priceGte // 가격 이상 검색

      let priceGt = -1
      let priceLte = 0
      let onlyGt = false

      if (values.length < 1 || values.length > 4) return {} // 전체 검색

      values.forEach((value) => {
        // TODO CHECK :: 무료(price2) 고려
        if (value === 'price3') {
          priceGt = 0;
          if (priceLte < 5000) priceLte = 5000;
        } else if (value === 'price4') {
          if (priceGt < 0 || priceGt > 5000) priceGt = 5000;
          if (priceLte < 10000) priceLte = 10000;
        } else if (value === 'price5') {
          if (priceGt < 0 || priceGt > 10000) priceGt = 10000;
          if (priceLte < 30000) priceLte = 30000;
        } else if (value === 'price4') {
          if (priceGt < 0 || priceGt > 30000) priceGt = 30000;
          priceLte = 0;
          onlyGt = true;
        }
      });

      if (onlyGt) return {priceGt: priceGt}
      else return {priceGt: priceGt, priceLte: priceLte}

    }
    , fnChgDateString: function (_date) { //날자값 변경
      if (_date == null || _date === '') return ''

      let year = _date.getFullYear();
      let tmpMonth = _date.getMonth() + 1;
      let tmpDate = parseInt(_date.getDate());
      let date = '';
      let month = '';
      if (tmpMonth < 10) {
        month = "0" + tmpMonth;
      } else {
        month = tmpMonth;
      }
      if (tmpDate < 10) {
        date = "0" + tmpDate;
      } else {
        date = tmpDate;
      }
      return year + "-" + month + "-" + date
    }
    , fnDateFormatForSearch() {
      let vm = this;
      const kind = vm.expInfoListModel.dateKind;
      const sdt = vm.fnChgDateString(vm.expInfoListModel.startDate); // yyyy-mm-dd
      const edt = vm.fnChgDateString(vm.expInfoListModel.endDate);

      // const sname = kind + 'StartDt'
      // const ename = kind + 'EndDt'
      // return {[sname]: sdt, [ename]: edt}

      return {dateKind: kind, dateStart: sdt, dateEnd: edt}
    }
    , maxLength3: function (li) {
      return Math.min(8, Math.ceil(li.length / 3))
    }
    , getSearch: async function () {
      let vm = this;
      if(vm.mbMainMode == true && vm.searchModel.kword == '') {
        swal('검색어를 입력하세요');
        return;
      }
      vm.fnClickFilter('');
      if(vm.searchModel.kword != '') {
        vm.mbMainMode = false;
      } else {
        vm.mbMainMode = true;
      }

      vm.fnCloseFilter();

      vm.viewYnModel.mbFilter.status = false;
      vm.programp = 1;
      vm.basep = 1;
      vm.clubp = 1;
      vm.galleryp = 1;
      vm.newsp = 1;
      vm.realinfop = 1;
      vm.searchModel.dpword = vm.searchModel.kword;
      TotalSearchMykeyword.addMyKeyword(vm.searchModel.kword, 10); // 내가 찾은 검색어 추가
      this.showInputArea = false;

      // const p_price = vm.fnPriceFormatForSearch(); // 가격 검색용 파라미터
      const p_date = vm.fnDateFormatForSearch();  // 기간 검색용 파라미터

      let param = {
        query: vm.searchModel.kword, // 검색어
        // collection   : vm.searchModel.collection, // 검색 컬렉션 명
        collection: vm.expInfoListModel.collectionValues.join(','), // 검색 컬렉션
        areaCd: vm.expInfoListModel.regionValues.join('|'), // 지역
        progressCd: vm.expInfoListModel.progressValues.join('|'), // 진행상태
        targetCd: vm.expInfoListModel.scopeValues.join('|'), // 대상
        capabilityCd: vm.expInfoListModel.areaValues.join('|'), // 역량
        affiliationCd: vm.expInfoListModel.affValues.join('|'), // 계열
        priceValues: vm.expInfoListModel.priceValues.join('|'), // 가격
        listCount: 100, // 한 페이지당 3개
        sort: 'PROGRESS_ORDER/ASC,RANK/DESC,DATE/DESC',
        // ...p_price,
        ...p_date,
      }

      Axios.get("/search/totalCustomSearch.do", {params: param}).then(function (response) {
        vm.viewModel = response.data;
        vm.viewModel.totalCount = 0;
        for (let key in vm.viewModel) {
          if(vm.viewModel[key].nameEn != 'afterschool' && vm.viewModel[key].nameEn != 'space' && vm.viewModel[key].nameEn != 'teacher') {
            const map = vm.viewModel[key];
            const tot = map['totalCount'];
            if (tot != undefined) {
              vm.viewModel.totalCount += tot;
            }
            vm.viewYnModel[key] = tot > 0 // 결과건수가 있을 때에만 보임
          }
        }
        if (vm.viewModel.program.searchResultList.length > 0) {
          vm.viewModel.program.searchResultList.forEach(function (item) {
            const nameStr = item.AFFILIATION_NAME; // 융합,예체능
            let affList = [];

            vm.viewModel.program.searchResultList.forEach(function (item) {
              if (item.zzimYn == "N") {
                item.isZzim = false;
              } else if (item.zzimYn == "Y") {
                item.isZzim = true;
              }
            });

            if (nameStr == null || nameStr === '') {
              item.affList = affList;
            } else {

              let _affNm = nameStr.split(",");

              _affNm.forEach(function (item) {
                let affCode = "";

                switch (item) {
                  case "인문과학":
                    affCode = "dpt_label dpt01";
                    break;
                  case "사회과학":
                    affCode = "dpt_label dpt02";
                    break;
                  case "상경":
                    affCode = "dpt_label dpt03";
                    break;
                  case "사범(교육)":
                    affCode = "dpt_label dpt04";
                    break;
                  case "자연과학":
                    affCode = "dpt_label dpt05";
                    break;
                  case "공학":
                    affCode = "dpt_label dpt06";
                    break;
                  case "의학/보건":
                    affCode = "dpt_label dpt07";
                    break;
                  case "예체능":
                    affCode = "dpt_label dpt08";
                    break;
                  case "융합":
                    affCode = "dpt_label dpt09";
                    break;
                }

                let affItem = {code: affCode, title: item}
                affList.push(affItem);
              });
              item.affList = affList;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });


      // 연관검색어
      const retRecomm = await Axios.get("/search/recommendSimple.do", {params: {query: vm.searchModel.kword}});
      // console.log("retRecomm = ", retRecomm)
      this.recommendList = retRecomm?.data?.list ?? []

      // this.recommendList =

    }
    , fnGoDetail(kind, uidKey) {
      if (kind === 'program') { // 진로체험활동
        location.href = "/customer/expinfo/detailExpinfo?uidKey=" + uidKey;
      } else if (kind === 'homebase_club' || kind === 'homebase_challenge') { // 동아리 콘텐츠 or 60초 챌린지
        location.href = "/customer/homebase/contentsDetail?paramUid=" + uidKey;
      } else if (kind === 'facility') { // 시설대관
        location.href = "/customer/notice/facilityDetail?uidKey=" + uidKey;
      } else if (kind === 'homebase_channel') { // 동아리
        location.href = "/customer/homebase/homeBaseDetail?paramUid=" + uidKey;
      } else if (kind === 'homebase_gallery') { // 커뮤니티 갤러리
        location.href = "/customer/homebase/galleryDetail?paramUid=" + uidKey;
      } else if (kind === 'voice') { // 청소년 시민청원
        location.href = "/customer/voice/voiceDetail?paramUid=" + uidKey;
      } else if (kind === 'youthnews') { // 청소년기자단
        location.href = "/customer/youth/youthNewsDetail?paramUid=" + uidKey;
      } else if (kind === 'space') { // 마을공간
        location.href = "/customer/afterschool/space?tab=2&uidKey=" + uidKey;
      } else if (kind === 'teacher') { // 마을강사
        location.href = "/customer/afterschool/teacherDetail?uidKey=" + uidKey;
      } else if (kind === 'realinfo') { // 알통정보
        location.href = "/customer/realinfo/content/detail?uidKey=" + uidKey;
      } else if (kind === 'policy_inf') { // 알통정보
        location.href = uidKey;
      }

    }
    , fnGoAfterDetail(prgmcategory, uidKey) {
      if (prgmcategory === 'PRGMNVYTHNV01000') { // 진로체험활동
        location.href = "/customer/expinfo/detailExpinfo?uidKey=" + uidKey;
      } else { // 마을방과후
        location.href = "/customer/afterschool/program/detail?tab=3&uidKey=" + uidKey;
      }
    }
    ,
    fnScrollToLeft: function () {
      var value = $('#search-gubun').scrollLeft() - 100;
      var max = $('#search-gubun')[0].scrollWidth - $('#search-gubun')[0].clientWidth;
      var min = 0;
      if (value < min) {
        value = min;
      }
      if (value == min) {
        this.leftAvail = false;
      } else {
        this.leftAvail = true;
      }
      if (value < max) {
        this.rightAvail = true;
      }
      $('#search-gubun').animate({
        scrollLeft: value
      }, 300);

    },
    fnScrollToRight: function () {
      var value = $('#search-gubun').scrollLeft() + 100;
      var max = $('#search-gubun')[0].scrollWidth - $('#search-gubun')[0].clientWidth;
      if (value > max ) {
        value = max;
      }
      if (value == max) {
        this.rightAvail = false;
      } else {
        this.rightAvail = true;
      }
      if (value > 0) {
        this.leftAvail = true;
      }
      $('#search-gubun').animate({
        scrollLeft: value
      }, 300);

    }
    , fnGoMoreList(kind) { // 더보기
      let vm = this;

      // TODO CHECK :: 가격 조건 추가
      // const p_price = vm.fnPriceFormatForSearch(); // 가격 검색용 파라미터

      const sdt = vm.fnChgDateString(vm.expInfoListModel.startDate); // yyyy-mm-dd
      const edt = vm.fnChgDateString(vm.expInfoListModel.endDate);

      const url = "/customer/expinfo/share/search_exp?"
        + "kind=" + kind
        + "&title=" + encodeURIComponent(vm.searchModel.kword)
        + "&area=" + encodeURIComponent(vm.expInfoListModel.regionValues.join("|"))
        + "&progress=" + encodeURIComponent(vm.expInfoListModel.progressValues.join("|"))
        + "&target=" + encodeURIComponent(vm.expInfoListModel.scopeValues.join("|"))
        + "&cpb=" + encodeURIComponent(vm.expInfoListModel.areaValues.join("|"))
        + "&aff=" + encodeURIComponent(vm.expInfoListModel.affValues.join("|"))
        + "&price=" + encodeURIComponent(vm.expInfoListModel.priceValues.join("|"))
        + "&dateKind=" + vm.expInfoListModel.dateKind
        + "&dateStart=" + encodeURIComponent(sdt)
        + "&dateEnd=" + encodeURIComponent(edt);

      location.href = url
    }
    // 체크박스 초기화
    , resetChecks(itemName) {
      if (itemName === "collection") {
        this.expInfoListModel.collectionValues = [];
        this.expInfoListModel.allCollectionChecked = false;
      } else if (itemName === "area") {
        this.expInfoListModel.allAreaChecked = false;
        this.expInfoListModel.regionValues = [];

      } else if (itemName === "scope") {
        this.expInfoListModel.allScopeChecked = false;
          this.expInfoListModel.scopeValues = [];
      } else if (itemName === "progress") {
        this.expInfoListModel.allProgressChecked = false;
          this.expInfoListModel.progressValues = [];
      } else if (itemName === "price") {
        this.expInfoListModel.allPriceChecked = false;
          this.expInfoListModel.priceValues = [];
      } else if (itemName === "ability") {
        this.expInfoListModel.allAbilityChecked = false;
          this.expInfoListModel.areaValues = [];
      } else if (itemName === "line") {
        this.expInfoListModel.allLineChecked = false;
          this.expInfoListModel.affValues = [];
      }
    }

    //체크박스 전체 클릭시
    , allChecked(itemName) {

      if (itemName === "collection") {
        this.expInfoListModel.allCollectionChecked = !this.expInfoListModel.allCollectionChecked;
        if (this.expInfoListModel.allCollectionChecked === false) {
          this.expInfoListModel.collectionValues = [];
        } else {
          this.expInfoListModel.collectionValues = [];
          for (let i in this.expInfoListModel.collectionList) {
            this.expInfoListModel.collectionValues.push(this.expInfoListModel.collectionList[i].value);
          }
        }
      } else if (itemName === "area") {
        this.expInfoListModel.allAreaChecked = !this.expInfoListModel.allAreaChecked;
        if (this.expInfoListModel.allAreaChecked === false) {
          this.expInfoListModel.regionValues = [];
        } else {
          this.expInfoListModel.regionValues = [];
          for (let i in this.expInfoListModel.regionList) {
            this.expInfoListModel.regionValues.push(this.expInfoListModel.regionList[i].cmm_sys_cd);
          }
        }
      } else if (itemName === "scope") {
        this.expInfoListModel.allScopeChecked = !this.expInfoListModel.allScopeChecked;
        if (this.expInfoListModel.allScopeChecked === false) {
          this.expInfoListModel.scopeValues = [];
        } else {
          this.expInfoListModel.scopeValues = [];
          for (let i in this.expInfoListModel.scopeList) {
            this.expInfoListModel.scopeValues.push(this.expInfoListModel.scopeList[i].cmm_sys_cd);
          }
        }
      } else if (itemName === "progress") {
        this.expInfoListModel.allProgressChecked = !this.expInfoListModel.allProgressChecked;
        if (this.expInfoListModel.allProgressChecked === false) {
          this.expInfoListModel.progressValues = [];
        } else {
          this.expInfoListModel.progressValues = [];
          for (let i in this.expInfoListModel.progressList) {
            this.expInfoListModel.progressValues.push(this.expInfoListModel.progressList[i].cmm_sys_cd);
          }
        }
      } else if (itemName === "price") {
        this.expInfoListModel.allPriceChecked = !this.expInfoListModel.allPriceChecked;
        if (this.expInfoListModel.allPriceChecked === false) {
          this.expInfoListModel.priceValues = [];
        } else {
          this.expInfoListModel.priceValues = [];
          for (let i in this.expInfoListModel.priceList) {
            this.expInfoListModel.priceValues.push(this.expInfoListModel.priceList[i]);
          }
        }
      } else if (itemName === "ability") {
        this.expInfoListModel.allAbilityChecked = !this.expInfoListModel.allAbilityChecked;
        if (this.expInfoListModel.allAbilityChecked === false) {
          this.expInfoListModel.areaValues = [];
        } else {
          this.expInfoListModel.areaValues = [];
          for (let i in this.expInfoListModel.areaList) {
            this.expInfoListModel.areaValues.push(this.expInfoListModel.areaList[i].cmm_sys_cd);
          }
        }
      } else if (itemName === "line") {
        this.expInfoListModel.allLineChecked = !this.expInfoListModel.allLineChecked;
        if (this.expInfoListModel.allLineChecked === false) {
          this.expInfoListModel.affValues = [];
        } else {
          this.expInfoListModel.affValues = [];
          for (let i in this.expInfoListModel.affList) {
            this.expInfoListModel.affValues.push(this.expInfoListModel.affList[i].cmm_sys_cd);
          }
        }
      }
    }
    //체크박스 개별 클릭시
    , checkItem: function (item, itemName) {
      let checked = 0;
      let vm = this;
      let tmpVal = item;
      let isChecked = null;
      let tmp = [];
      console.log("check Item", item, itemName);
      if (itemName === "collection") {

        if (vm.expInfoListModel.collectionValues.includes(tmpVal)) {
          isChecked = false;
        } else {
          isChecked = true;
        }
        let length = vm.expInfoListModel.collectionList.length;
        //체크 풀림
        if (isChecked === false) {
          tmp = vm.expInfoListModel.collectionValues.filter((element) => element !== tmpVal);
        } else { // 체크됨
          tmp = vm.expInfoListModel.collectionValues;
          tmp.push(tmpVal);
        }
        //값 검사
        vm.expInfoListModel.collectionList.forEach(function (item) {
          for (let i in tmp) {
            if (tmp[i] === item.value) {
              checked += 1;
            }
          }
        });
        vm.expInfoListModel.allCollectionChecked = checked !== length ? false : true;
        vm.expInfoListModel.collectionValues = tmp;
      } else if (itemName === "area") {
        if (vm.expInfoListModel.regionValues.includes(tmpVal)) {
          isChecked = false;
        } else {
          isChecked = true;
        }
        let length = vm.expInfoListModel.regionList.length;
        //체크 풀림
        if (isChecked === false) {
          tmp = vm.expInfoListModel.regionValues.filter((element) => element !== tmpVal);
        } else { // 체크됨
          tmp = vm.expInfoListModel.regionValues;
          tmp.push(tmpVal);
        }
        //값 검사
        vm.expInfoListModel.regionList.forEach(function (item) {
          for (let i in tmp) {
            if (tmp[i] === item.cmm_sys_cd) {
              checked += 1;
            }
          }
        });
        vm.expInfoListModel.allAreaChecked = checked !== length ? false : true;
        vm.expInfoListModel.regionValues = tmp;
      } else if (itemName === "scope") {
        if (vm.expInfoListModel.scopeValues.includes(tmpVal)) {
          isChecked = false;
        } else {
          isChecked = true;
        }
        let length = vm.expInfoListModel.scopeList.length;
        //체크 풀림
        if (isChecked === false) {
          tmp = vm.expInfoListModel.scopeValues.filter((element) => element !== tmpVal);
        } else { // 체크됨
          tmp = vm.expInfoListModel.scopeValues;
          tmp.push(tmpVal);
        }
        //값 검사
        vm.expInfoListModel.scopeList.forEach(function (item) {
          for (let i in tmp) {
            if (tmp[i] === item.cmm_sys_cd) {
              checked += 1;
            }
          }
        });
        vm.expInfoListModel.allScopeChecked = checked !== length ? false : true;
        vm.expInfoListModel.scopeValues = tmp;
      } else if (itemName === "progress") {
        if (vm.expInfoListModel.progressValues.includes(tmpVal)) {
          isChecked = false;
        } else {
          isChecked = true;
        }
        let length = vm.expInfoListModel.progressList.length;
        //체크 풀림
        if (isChecked == false) {
          tmp = vm.expInfoListModel.progressValues.filter((element) => element !== tmpVal);
        } else { // 체크됨
          tmp = vm.expInfoListModel.progressValues;
          tmp.push(tmpVal);
        }
        //값 검사
        vm.expInfoListModel.progressList.forEach(function (item) {
          for (let i in tmp) {
            if (tmp[i] === item.cmm_sys_cd) {
              checked += 1;
            }
          }
        });
        vm.expInfoListModel.allProgressChecked = checked !== length ? false : true;
        vm.expInfoListModel.progressValues = tmp;
      } else if (itemName === "price") {
        if (vm.expInfoListModel.priceValues.includes(tmpVal)) {
          isChecked = false;
        } else {
          isChecked = true;
        }
        let length = vm.expInfoListModel.priceList.length;
        //체크 풀림
        if (isChecked === false) {
          tmp = vm.expInfoListModel.priceValues.filter((element) => element !== tmpVal);
        } else { // 체크됨
          tmp = vm.expInfoListModel.priceValues;
          tmp.push(tmpVal);
        }
        //값 검사
        vm.expInfoListModel.priceList.forEach(function (item) {
          for (let i in tmp) {
            if (tmp[i] === item) {
              checked += 1;
            }
          }
        });
        vm.expInfoListModel.allPriceChecked = checked !== length ? false : true;
        vm.expInfoListModel.priceValues = tmp;
      } else if (itemName === "ability") {
        if (vm.expInfoListModel.areaValues.includes(tmpVal)) {
          isChecked = false;
        } else {
          isChecked = true;
        }
        let length = vm.expInfoListModel.areaList.length;
        //체크 풀림
        if (isChecked === false) {
          tmp = vm.expInfoListModel.areaValues.filter((element) => element !== tmpVal);
        } else { // 체크됨
          tmp = vm.expInfoListModel.areaValues;
          tmp.push(tmpVal);
        }
        //값 검사
        vm.expInfoListModel.areaList.forEach(function (item) {
          for (let i in tmp) {
            if (tmp[i] === item.cmm_sys_cd) {
              checked += 1;
            }
          }
        });
        vm.expInfoListModel.allAbilityChecked = checked !== length ? false : true;
        vm.expInfoListModel.areaValues = tmp;
      } else if (itemName === "line") {
        if (vm.expInfoListModel.affValues.includes(tmpVal)) {
          isChecked = false;
        } else {
          isChecked = true;
        }
        let length = vm.expInfoListModel.affList.length;
        //체크 풀림
        if (isChecked === false) {
          tmp = vm.expInfoListModel.affValues.filter((element) => element !== tmpVal);
        } else { // 체크됨
          tmp = vm.expInfoListModel.affValues;
          tmp.push(tmpVal);
        }
        //값 검사
        vm.expInfoListModel.affList.forEach(function (item) {
          for (let i in tmp) {
            if (tmp[i] === item.cmm_sys_cd) {
              checked += 1;
            }
          }
        });
        vm.expInfoListModel.allLineChecked = checked !== length ? false : true;
        vm.expInfoListModel.affValues = tmp;
      }
    }
    , fnSwalAlert(_text) {
      swal({
        text: _text,
        closeOnClickOutside: false,
        // icon       : this.fnOnLoadSwalImageData('warning'),
        buttons: {
          confirm: {
            text: "확인",
            value: true
          },
          cancel: {
            text: "취소",
            value: false,
            visible: false
          }
        }
      });
    }
    , fnSwalSuccess(_text, successFunction) {
      let vm = this;

      swal({
        text: _text,
        closeOnClickOutside: false,
        // icon : vm.fnOnLoadSwalImageData("success"),
        buttons: {
          confirm: {
            text: "확인",
            value: true,
            visible: true
          },
          cancel: {
            text: "취소",
            value: false,
            visible: false
          }
        }
      }).then(result => {
        if (result) {
          if (successFunction != null) {
            successFunction();
          }
        }
      });
    }
    , fnOnLoadSwalImageData: function (value) {
      let _icon = "/design/common/images/sub/img_alert_" + value + ".png";
      return _icon;
    },


    doShowInputArea: function () {
      this.showInputArea = true
      this.loadSearchLayerData().then()
    },
    doHideInputArea: function () {
      this.showInputArea = false
    },
    // getSearch: function () {
    //   TotalSearchMykeyword.addMyKeyword(this.title, 10) // 내가 찾은 검색어 추가
    //
    //   // if (this.isMobile) { // TODO CHECK :: 통합검색 모바일 대기중이므로 기존 화면 사용
    //   // location.href = "/customer/expinfo/share/search?title=" + this.title; // 기존 통합검색
    //   // } else if (location.pathname.indexOf('/customer/expinfo/share/search_exp') > -1) {
    //   //   location.href = "/customer/expinfo/share/search_exp?title=" + this.title; // 검색엔진 통합검색 페이징
    //   // } else {
    //   location.href = "/customer/expinfo/share/search2?title=" + this.title; // 검색엔진 통합검색
    //   // }
    // },
    goSearch: function (word) {

      if (word == null) {
        if(this.searchKeyword == '') {
          swal("검색어를 입력해주세요");
          return;
        } else {
          location.href = '/customer/expinfo/share/search2?title=' + this.searchKeyword;
        }
      } else {
        if(word == '') {
          swal("검색어를 입력해주세요");
          return;
        } else {
          location.href = '/customer/expinfo/share/search2?title=' + word;
        }
      }
    },
    doSearch: function (word) {
      this.title = word
      this.getSearch()
    },
    /** 검색영역 데이터 로딩 */
    loadSearchLayerData: async function () {
      this.loadPopwordList().then() // 인기검색어 로딩
      this.myKeywordLoad(); // 최근 검색어 로딩
    },
    /* 인기검색어 로딩 */
    loadPopwordList: async function () {
      // 조회범위 : D 일 W 주 M 월
      const ret = await Axios.get("/search/popword.do", {params: {range: 'M'}})
      // console.log("popwordList = ", ret.data?.Data?.Query) // content : "검색광고" count : 1 id : 2 updown : "U"
      this.popwordList = ret.data?.Data?.Query ?? []
    },
    /*최근 검색어 로딩*/
    myKeywordLoad: function () {
      this.mywordList = TotalSearchMykeyword.getMyKeywordAll()
    },
    /*최근 검색어 하나 삭제*/
    myKeywordDel: function (word) {
      TotalSearchMykeyword.removeMyKeyword(word)
      this.myKeywordLoad();
    },
    /*최근 검색어 전체 삭제*/
    myKeywordRemoveAll: function () {
      TotalSearchMykeyword.removeAllMyKeyword()
      this.myKeywordLoad();
    },
    /* 자동완성 */
    onChangeTitle: debounce(async function (n) {
      // console.log("***" + n)
      // http://localhost:8080/search/ark.do?query=캠프
      // console.log("쿼리 = " + n)
      const ret = await Axios.get("/search/arkSimple.do", {params: {query: n}})
      // console.log(ret)
      this.autowordList = ret.data?.list ?? []
      // console.log("this.autowordList = ", this.autowordList)
      // "hkeyword": "<font style='font-size:13px'><font style='color:#CC6633'>1</font>2월</font>",
      // "keyword": "12월",
      // "count": 30,
      // "type": 1,
      // "linkname": "",
      // "linkurl": ""
    }, 300),


  }
  , computed: {
    // 현재 선택된 탭에 따라 표시할 카운트를 계산
    currentCount() {
      if (!this.viewModel) {
        return 0;
      }

      if (this.mode === 'thumb') {
        return this.viewModel.totalCount || 0;
      } else if (this.mode === 'detail' && this.target) {
        const targetKey = this.target === 'challenge' ? 'homebase_challenge' : this.target;
        if (this.viewModel[targetKey] && this.viewModel[targetKey].totalCount) {
          return this.viewModel[targetKey].totalCount;
        }
        return 0;
      }
      return this.viewModel.totalCount || 0;
    },
    // 현재 선택된 탭의 이름
    currentTabName() {
      const tabNames = {
        'program': '체험프로그램',
        'challenge': '청소년 숏폼',
        'homebase_channel': '동아리',
        'homebase_club': '동아리 홍보보드',
        'homebase_gallery': '진로커뮤니티',
        'realinfo': '정보몽땅',
        'youthnews': '청소년기자단',
        'facility': '서울시공공예약프로그램',
        'voice': '청소년 시민청원',
        'policy_inf': '청소년 정책소개'
      };

      if (this.mode === 'thumb' || !this.target) {
        return '전체';
      }

      return tabNames[this.target] || '전체';
    }
  }
  , watch: {
    title(n) {
      this.onChangeTitle(n)
    },
    searchStartDate: function (newValue, oldValue) {
      let vm = this;
      let endDt = vm.expInfoListModel.endDate;

      if ((endDt != null && endDt !== "") && (newValue != null && newValue !== "") && endDt < newValue) {
        vm.fnSwalAlert("시작일이 종료일보다 이후일 수 없습니다.");
        vm.searchStartDate = "";
        vm.expInfoListModel.startDate = "";
      } else {
        vm.expInfoListModel.startDate = newValue;
      }
    },
    searchEndDate: function (newValue, oldValue) {
      let vm = this;
      let startDt = vm.searchModel.startDate;

      if ((startDt != null && startDt !== "") && (newValue != null && newValue !== "") && startDt > newValue) {
        vm.fnSwalAlert("종료일이 시작일보다 이전일 수 없습니다.");
        vm.searchEndDate = "";
        vm.expInfoListModel.endDate = "";
      } else {
        vm.expInfoListModel.endDate = newValue;
      }
    }
  }
  , filters: {
    currency: function (value) {
      let num = new Number(value);
      return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
    }
  }
});
